import React, { Fragment, useState, useEffect } from 'react';
import axios from "axios";
import styles from "./TeacherModal.module.sass";
import ModalContent from './ModalContent';
import Spinner from "../../Spinner";

// What each warning code means, for the summary line.
const WARNING_LABELS = {
  small_class: 'unusually small class',
  display_name: 'display name not First Last / Salutation Last',
  display_grade: 'display grade not written out',
  linked_record: 'linked staff record missing, named differently, or without this season\'s picture',
};

const TeacherList = ({ schoolId }) => {
  const [data, setData] = useState();

  // Teachers with at least one real warning, and how many of each kind.
  const summarize = (teachers) => {
    const counts = {};
    let flagged = 0;
    teachers.forEach((teacher) => {
      const real = (teacher.warnings || []).filter((w) => (w.level === 'warning' || w.level === 'alert'));
      if (real.length) flagged += 1;
      real.forEach((w) => { counts[w.code] = (counts[w.code] || 0) + 1; });
    });
    return { flagged, counts };
  };

  const getTeachers = () => {
    axios
      .get(`/api/v1/students/students_per_teacher?school_id=${schoolId}`)
      .then((data) => {
        setData(data.data.data)
      })
  }

  useEffect(() => {
    getTeachers();
  }, [schoolId])

  return (
    <Fragment>
      {!data && <Spinner color="blue" />}
      {data && (
        <>
          {data.some((teacher) => teacher.needs_review) && (
            <p>
              Highlighted teachers need review — no staff record could be confidently
              matched, so their display name must be entered or linked by hand.
            </p>
          )}
          <hr />
          {(() => {
            const { flagged, counts } = summarize(data);
            const detail = Object.keys(counts)
              .map((code) => `${counts[code]} ${WARNING_LABELS[code] || code}`)
              .join('; ');
            return flagged === 0 ? (
              <div className={styles.summaryOk}>
                <strong>Check Teachers:</strong>
                {` nothing flagged for ${data.length} teachers.`}
              </div>
            ) : (
              <div className={styles.summary}>
                <strong>Check Teachers:</strong>
                {` ${flagged} of ${data.length} teachers need a look (yellow rows): ${detail}.`}
              </div>
            );
          })()}
          <ModalContent data={data} schoolId={schoolId} />
        </>
      )}
    </Fragment>
  )
}

export default TeacherList;
